import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Flip } from 'gsap/Flip';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import handleTabs from './util/handle-tabs';

gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin);

const init = (isRM) => {
  // refresh ScrollTrigger
  const refreshST = () => {
    ScrollTrigger.refresh();
  };

  const tabPatterns = document.querySelectorAll('[data-tab-pattern]');

  if (tabPatterns) {
    const tabPatternsArray = Array.from(tabPatterns);

    tabPatternsArray.forEach(function (tabPattern) {
      const tabList = tabPattern.querySelector('[data-tablist]');
      const tabNodeList = tabPattern.querySelectorAll('[data-tab]');
      const tabPanels = tabPattern.querySelectorAll('[data-tab-panel]');

      handleTabs(tabList, tabNodeList, tabPanels);
    });
  }

  const accordionBlocks = document.querySelectorAll('[data-accordion-block]');

  function closeAccordionPanel(trigger) {
    const triggerId = trigger.getAttribute('aria-controls');
    const triggerPanel = document.getElementById(triggerId);
    trigger.setAttribute('aria-expanded', false);

    if (triggerPanel) {
      triggerPanel.classList.remove('accordion__panel--show');
    }
  }

  function toggleAccordion(e, group) {
    const target = e.target;
    const contents = group.querySelectorAll('.accordion__panel');
    const triggers = group.querySelectorAll('[data-accordion-trigger]');
    const state = Flip.getState(contents, group);

    // Close all other triggers
    triggers.forEach((el) => {
      if (target !== el) {
        closeAccordionPanel(el);
      }
    });

    // Toggle clicked trigger.
    const isActive =
      target.getAttribute('aria-expanded') === 'true' ? true : false;

    target.setAttribute('aria-expanded', !isActive ? true : false);

    const triggerId = target.getAttribute('aria-controls');
    const triggerPanel = document.getElementById(triggerId);
    if (triggerPanel) {
      triggerPanel.classList.toggle('accordion__panel--show');
    }

    if (!isRM) {
      Flip.from(state, {
        duration: 0.3,
        onComplete: () => {
          refreshST();
          gsap.to(window, {
            duration: 0.125,
            ease: 'sine',
            scrollTo: { y: target, offsetY: 80 }
          });
        }
      });
    } else {
      refreshST();
    }
  }

  if (accordionBlocks) {
    const accordionBlocksArray = Array.from(accordionBlocks);

    accordionBlocksArray.forEach(function (accordionBlock) {
      const triggers = accordionBlock.querySelectorAll(
        '[data-accordion-trigger]'
      );

      // When any accordion trigger is activated, show it's respective panel and collapse all others
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', (e) => {
          toggleAccordion(e, accordionBlock);
        });
      });
    });
  }

  /**
   * Add aria-current="page" to navigation anchor element if the
   * anchor pathname matches window.location.pathname
   */
  const currentHref = window.location.href;

  document.querySelectorAll('[data-link]').forEach(function (link) {
    if (currentHref === link.href) {
      link.setAttribute('aria-current', 'page');
    }
  });

  /**
   * Handle aria-expanded state if resource filter toggle button is clicked.
   * If aria-expanded is true, show resource filters. Otherwise, hide them.
   */
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('[data-filters]');
  const clearFilters = document.querySelector('[data-clear-filters]');

  if (filterToggle && filters && clearFilters) {
    filterToggle.addEventListener('click', function () {
      const state = Flip.getState(filters);
      this.getAttribute('aria-expanded') === 'false'
        ? this.setAttribute('aria-expanded', 'true')
        : this.setAttribute('aria-expanded', 'false');

      if (filterToggle.getAttribute('aria-expanded') === 'true') {
        this.setAttribute('aria-label', 'Hide Filters');
        filters.classList.add('archive__filters-wrap--visible');
      } else {
        this.setAttribute('aria-label', 'Show Filters');
        filters.classList.remove('archive__filters-wrap--visible');
      }
      if (!isRM) {
        Flip.from(state, {
          duraiton: 0.4,
          onComplete: refreshST
        });
      } else {
        refreshST();
      }
    });

    /**
     * On click, call Facets reset function to uncheck checkboxes.
     */
    clearFilters.addEventListener('click', function () {
      FWP.reset();
    });
  }

  // facet filtering animation.... Not great, but it'll do...
  if (!isRM) {
    document.addEventListener('facetwp-refresh', function () {
      gsap.to('.facetwp-template', { y: 15, opacity: 0 });
    });

    document.addEventListener('facetwp-loaded', function () {
      gsap.fromTo(
        '.facetwp-template',
        { y: 15, opacity: 0 },
        { y: 0, opacity: 1 }
      );
    });
  }

  refreshST();
};

export { init };
